import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";

export default function ShareUrlDialog({ open, onClose, url = "" }) {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation("product_page_info");

  // reset copied state when dialog opens/closes or url changes
  useEffect(() => {
    if (!open) setCopied(false);
  }, [open, url]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url || window.location.href);
      setCopied(true);
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = url || window.location.href;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        setCopied(true);
      } catch {
        setCopied(false);
      }
    }
  };

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {t("share_url_title", { defaultValue: "رابط المشاركة" })}
        </Typography>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <TextField
            value={url || (typeof window !== "undefined" ? window.location.href : "")}
            fullWidth
            size="small"
            InputProps={{ readOnly: true }}
          />
          <Button variant="contained" onClick={handleCopy}>
            {t("copy", { defaultValue: "نسخ" })}
          </Button>
        </Box>
        {copied && (
          <Typography variant="body2" color="success.main" sx={{ mt: 1 }}>
            {t("copied", { defaultValue: "تم النسخ" })}
          </Typography>
        )}
      </Box>
    </Dialog>
  );
}
